import React, { useEffect, useState } from "react";
import { columns } from "./columns";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { fetchLeaveRequests, setAdminSearch, setAdminStatus, setAdminType } from "@/features/leaveRequests/leaveRequestSlice";
import { useDebounce } from "@/hooks/useDebounce";
import AdminDataTableWithToolbar from "./AdminDataTableWithToolbar";
import { Button } from "@/components/ui/button";

function AdminLeaveRequestDataTable() {
  const dispatch = useAppDispatch();
  const { adminRequests, error, adminPagination, adminRequestsFilters: { search, type, status } } = useAppSelector(
    (state) => state.leaveRequests
  );
  const [typesSelected, setTypesSelected] = useState<string[]>(type);
  const [statusSelected, setStatusSelected] = useState<string[]>(status);
  const [localSearch, setLocalSearch] = useState(search);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(setAdminType(typesSelected));
  }, [typesSelected]);

  useEffect(() => {
    dispatch(setAdminStatus(statusSelected));
  }, [statusSelected]);

  useEffect(() => {
    dispatch(setAdminSearch(localSearch));
  }, [localSearch]);

  const debouncedSearch = useDebounce(localSearch, 300);



  const pageSize = 7; // or any size you want

  useEffect(() => {
    dispatch(fetchLeaveRequests({ page: currentPage, limit: pageSize, search: debouncedSearch, status: status, type: type }));

  }, [dispatch, currentPage, debouncedSearch, type, status]);


  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    // const totalPages = Math.ceil((pagination?.totalElements || 0) / pageSize);
    if (currentPage < adminPagination.totalPages) {
      setCurrentPage((prev) => prev + 1);
    }

  };

  useEffect(() => {
    if (adminPagination.totalPages > 0) {
      setCurrentPage(1);
    } else {
      setCurrentPage(0); // no pages available
    }
  }, [debouncedSearch, JSON.stringify(typesSelected), JSON.stringify(statusSelected), adminPagination.totalPages]);

  return (
    <div className="rounded-md w-full h-full p-5 bg-white outline outline-2 outline-gray-100 flex flex-col">
      <div className="flex justify-between items-center mb-2 sticky top-0 bg-white z-1">
        <div className="flex flex-col gap-2">
          <div className="font-bold mb-0 text-2xl flex-none">
            Recent Staff Leave Requests
          </div>
          <div className="text-gray-500 text-sm">
            View all leave requests made by staff members.
          </div>
        </div>
      </div>
      <div className="overflow-auto flex-grow">
        <AdminDataTableWithToolbar
          columns={columns()}
          data={adminRequests}
          containerClassname="h-full"
          search={localSearch}
          setSearch={setLocalSearch}
          typesSelected={typesSelected}
          setTypesSelected={setTypesSelected}
          statusSelected={statusSelected}
          setStatusSelected={setStatusSelected}
        />
      </div>
      <div className="flex justify-between items-center mt-4">
        <Button
          onClick={handlePrev}
          variant={"outline"}
          size={"sm"}
          disabled={currentPage <= 1}
        >
          Previous
        </Button>
        <span className="text-sm text-gray-600">
          Page {currentPage} of {adminPagination.totalPages}
        </span>
        <Button
          onClick={handleNext}
          disabled={currentPage >= Math.ceil((adminPagination?.totalElements || 0) / pageSize)}
          variant={"outline"}
          size={"sm"}
        >
          Next
        </Button>
      </div>
    </div >
  );
}


export default AdminLeaveRequestDataTable;
